module.exports = __webpack_public_path__ + "media/mourning-dove-3.fede753d.mp3";